<template>
  <div class="clientes-search-list">
    <b-row>
      <b-col cols="12" xl="12">
        <b-form>
          <b-form-group
            label="Nombre Comercial / Razón Social:"
            label-for="nombre"
            :label-cols="4"
            horizontal>
            <b-form-input 
              id="nombre" 
              v-model= "nombre" 
              type="text">
            </b-form-input>
          </b-form-group>
        </b-form>
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <b-table hover  
            responsive="sm" 
            class="registro"
            :busy="tableBusy"
            :items="clientes" 
            :fields="clienteFields"
            :filter="nombre"
            :current-page="paginaActual"
            :per-page="registrosPorPagina"
            @filtered="onFiltered"
            @row-clicked="seleccionarCliente">
          <div slot="table-busy" class="text-center">
            <b-spinner class="table-spinner" label="Spinning" />
          </div>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" xl="12">  
        <nav>
          <b-pagination size="sm" 
            :total-rows="totalRegistros" 
            :per-page="registrosPorPagina" 
            v-model="paginaActual" 
            prev-text="Prev." next-text="Prox."/>
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>

export default {
  name: 'Clientes',
  props: {
    incluirInactivos: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      clientes: [],
      clienteFields: [
        {
          key: 'id',
          label: 'Cód.'
        },
        {
          key: 'nombre',
          label: 'Cliente',
          sortable: true
        },
        {
          key: 'razonSocial',
          label: 'Razón Social',
          sortable: true
        },
      ],

      tableBusy: false,

      /* Info de paginación */
      paginaActual: 1,
      totalPaginas: 1,
      registrosPorPagina: 5,
      totalRegistros: 0,

      nombre: null,
    }
  },
  computed: {
  },
  created() {
    this.getClientes();
  },  
  methods: {
    getClientes() {
      let params = {
        incluirInactivos: this.incluirInactivos
      }

      this.tableBusy = true;
      this.$store.dispatch('clientes/getList', params)
        .then(() => {
          this.clientes = this.$store.getters['clientes/list'];
          this.totalRegistros = this.clientes.length;
          this.tableBusy = false;
        })
    },
    seleccionarCliente (item) {
      this.$emit('clienteSeleccionado', item)
    },
    onFiltered(filteredItems) {
      this.totalRegistros = filteredItems.length
      this.paginaActual = 1
    }    
  },
}
</script>

<style>
  .clientes-search-list .registro table td[aria-colindex="1"] {
    width: 10%;
  }
  .clientes-search-list .registro table td[aria-colindex="2"],
  .clientes-search-list .registro table td[aria-colindex="3"] {
    width: 45%;
  }
</style>
